import React, {Component} from 'react';
import OrgMiniView from './OrgMiniView'
import ModalConfirm from '../ModalConfirm'
import LocalDate from '../LocalDate'
import LocalTime from '../LocalTime'

class OrganizzazioniTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let o = this.props.item

        let btnEdit=null;
        let btnDelete=null;
        if(this.props.readOnly === false){
            btnEdit = (
                    <a  className="ui pointer blue icon button" onClick={() => {this.props.onModificaOrganizzazione(o)}}>
                        <i
                            className="edit icon"

                        ></i>
                    </a>
            );

            btnDelete = (
                    <ModalConfirm   
                        msg={"Stai per cancellare l'organizzazione: " + o.nomeCompleto}
                        onClickOk={(ev) => (this.props.onDeleteOrganizzazione(ev, o))}
                    >
                        <a className="ui red icon button"><i className="trash icon"/></a>
                    </ModalConfirm>
            );
        }

        return (
            <tr>
                <td className="">
                    <div className="content">
                        {o.nomeCompleto}
                        <OrgMiniView item={o} />
                    </div>
                    <div className="content">
                        Creato il {o.creatoIl ?  <b><LocalDate data={o.creatoIl } /> <LocalTime data={o.creatoIl } /></b> : <b>?</b>} da <b>{o.creatoDa ? o.creatoDa.username : '?'}</b>&nbsp;
                        Modificato il {o.modificatoIl ?  <b><LocalDate data={o.modificatoIl } /> <LocalTime data={o.modificatoIl } /></b> : <b>?</b>} da <b>{o.modificatoDa ? o.modificatoDa.username : '?'}</b>
                    </div>
                </td>
                <td className="collapsing no-print">
                    {btnEdit}
                    {btnDelete}
                </td>
            </tr>)
    }
}

export default OrganizzazioniTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/OrganizzazioniTableRow.js
 **/